const uz = {
    meta: {
        title: "Marketpleys yoki o'z internet do'koni: 2026-yil hisobi",
        description:
            "Marketpleys komissiyasi 3–35% va logistika yig'imi 2–20 ming so'm. O'z do'koni qachon arzonroq bo'ladi — ochiq kalkulyator, jadval va qaytim muddati.",
        keywords: [
            "marketpleys yoki o'z internet do'koni",
            "Uzum Market komissiya qancha",
            "internet do'kon ochish narxi",
            "marketpleysda sotish foydalimi",
            "o'z onlayn do'konini ochish",
            "yunit iqtisod onlayn savdo",
        ],
    },
    h1: "Marketpleys yoki o'z internet-do'koni: qaysi variant ko'proq pul qoldiradi",
    lead:
        "Marketpleys sizga trafik beradi, lekin komissiya oladi. O'z do'koni komissiya olmaydi, lekin trafikni siz sotib olasiz. Qaysi biri foydaliroq — did masalasi emas, bitta jadvalga sig'adigan hisob.",
    category: "Elektron tijorat",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Bizga eng ko'p beriladigan savol shu: «Marketpleysda sotyapmiz, o'z saytimiz kerakmi?» Umumiy javob yo'q. Javob kategoriyangizga, o'rtacha chekingizga va oylik buyurtma soningizga bog'liq. Quyida hisobni ochiq ko'rsatamiz — o'z raqamlaringizni qo'yib chiqasiz.",
        },

        { type: "h2", text: "Nega bu savol aynan 2026-yilda keskinlashdi?" },
        {
            type: "p",
            text:
                "2025-yil yakuni bo'yicha O'zbekistonda elektron tijorat aylanmasi 22,7 trln so'mni tashkil etdi — bu 2020-yildagidan 22 barobardan ko'p, oldingi yilga nisbatan esa 1,5 barobar o'sish. Shu davrda elektron savdo platformalari soni 36 tadan 115 taga chiqdi. Bozor o'sdi, lekin u bilan birga sotuvchilar orasidagi raqobat ham o'sdi.",
        },
        {
            type: "p",
            text:
                "2026-yil 1-maydan Uzum Market komissiyani hisoblash mexanikasini o'zgartirdi. Endi u tovar narxiga emas, tovar kategoriyasiga bog'lanadi va diapazon keng — kategoriyaga qarab 3% dan 35% gacha. Shu sanadan yetkazib berish uchun qat'iy logistika yig'imi ham joriy etildi: tovar narxi va o'lchamiga qarab 2 000 so'mdan 20 000 so'mgacha.",
        },
        {
            type: "p",
            text:
                "Bu ikki o'zgarish sotuvchining yunit-iqtisodini qayta yozdi. Arzon va kichik tovarlarda qat'iy logistika yig'imi endi marjaning sezilarli qismini yeydi. Qimmat kategoriyalarda esa yuqori foiz og'ir keladi. Ilgari «komissiya o'rtacha shuncha» deb chamalash mumkin edi, endi har bir kategoriya alohida hisoblanadi.",
        },
        {
            type: "p",
            text:
                "Davlat tomondan ham signal bor: prezidentning 2026-yil 13-apreldagi qarori bilan 2030-yilga elektron tijorat aylanmasini 30 trln so'mga yetkazish vazifasi qo'yilgan. Kanal o'sishda davom etadi. Shuning uchun butun savdoni bitta platformaga bog'lab qo'yish tobora ko'proq xavf bo'lib bormoqda.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Marketpleys nimani beradi — buni kamsitmaslik kerak" },
        {
            type: "p",
            text:
                "Komissiyani sof xarajat deb ko'rish oson, lekin u evaziga siz real narsalar olasiz. Ularni hisobga olmasangiz, taqqoslash boshidanoq noto'g'ri chiqadi.",
        },
        {
            type: "list",
            items: [
                "Tayyor trafik. Xaridor tovarni qidirib platformaga o'zi keladi — siz uni sotib olmaysiz.",
                "Tayyor ishonch. Yangi brendga birinchi buyurtma berish qo'rquvini platforma o'z zimmasiga oladi.",
                "Tayyor logistika. Ombor, topshirish punktlari, kuryer va qaytarish oqimi allaqachon ishlaydi.",
                "Nol boshlang'ich sarmoya. Tovarni joylab, ertaga sotishni boshlash mumkin.",
                "Tez gipoteza tekshirish. Yangi tovar bozorga tushadimi — bir-ikki haftada bilib olasiz.",
            ],
        },
        {
            type: "p",
            text:
                "Shuning uchun biz hech qachon «marketpleysni tashlab keting» demaymiz. To'g'ri savol boshqacha yangraydi: qaysi aylanmadan boshlab ikkinchi kanal ochish pul keltiradi va u kanal nimani o'z zimmasiga oladi.",
        },

        { type: "h2", text: "Marketpleysda bitta buyurtma qanchaga tushadi?" },
        {
            type: "p",
            text:
                "Oylik aylanmani emas, bitta buyurtmani oxirigacha hisoblang. Faqat shunda ikkala kanalni bir tarozida ko'rish mumkin bo'ladi.",
        },
        {
            type: "ol",
            items: [
                "Komissiya: chek × kategoriya foizi. Uzumda bu 3% dan 35% gacha — o'z kategoriyangiz foizini sotuvchi kabinetidan oling, o'rtachani olmang.",
                "Logistika yig'imi: yetkazib berilgan har bir buyurtma uchun 2 000–20 000 so'm, tovar narxi va o'lchamiga qarab.",
                "Ichki reklama: pozitsiyani ushlab turish uchun sarf. Raqobatli kategoriyada bu doimiy band bo'lib qoladi.",
                "Qaytarishlar: qaytgan tovarning logistikasi va uning savdo holatidagi yo'qotishi.",
                "Aksiya va chegirmalar: platforma kampaniyalarida qatnashish amalda ko'pincha ixtiyoriy emas.",
            ],
        },
        {
            type: "p",
            text:
                "Ko'pchilik faqat birinchi bandni hisoblaydi. Aslida buyurtmaning to'liq narxi birinchi banddan sezilarli yuqori chiqadi — ayniqsa o'rtacha chek past bo'lgan kategoriyalarda.",
        },
        {
            type: "p",
            text:
                "Oddiy tekshiruv: bitta buyurtmadagi barcha yig'imlarni qo'shing va chekka bo'ling. Chiqqan foiz — sizning haqiqiy komissiyangiz. Amaliyotimizda u kabinetda ko'rinadigan raqamdan odatda bir necha punktga yuqori bo'ladi, chunki reklama va qaytarish alohida hisoblanadi.",
        },

        { type: "h2", text: "O'z do'koningizda bitta buyurtma qanchaga tushadi?" },
        {
            type: "p",
            text:
                "Bu yerda xarajat strukturasi boshqacha: foiz ancha kichik, lekin trafik pullik va sayt bir martalik sarmoyani talab qiladi.",
        },
        {
            type: "ol",
            items: [
                "Ekvayring komissiyasi. Payme, Click va Uzum ochiq tarif e'lon qilmaydi — foiz shartnomada individual belgilanadi va aylanmangizga bog'liq. Imzolashdan oldin aniq raqamni yozma so'rang.",
                "Trafik narxi: SEO, Google Ads yoki Instagram. Bitta buyurtma tannarxidagi eng katta va eng o'zgaruvchan band shu.",
                "Yetkazib berish: kuryer xizmati tarifi yoki o'z kuryeringizning tannarxi.",
                "Sayt amortizatsiyasi: ishlab chiqish narxini 12–24 oyga bo'lib, har bir buyurtmaga taqsimlang.",
                "Hosting, domen va texnik qo'llab-quvvatlash — kichik, lekin qat'iy oylik summa.",
            ],
        },
        {
            type: "p",
            text:
                "Asosiy farq shunda: marketpleysda xarajat aylanmaga proporsional o'sadi, o'z do'konida esa uning katta qismi qat'iy qoladi. Aylanma oshgani sayin bitta buyurtmaga tushadigan qat'iy xarajat kamayaveradi. Aynan shu narsa kesishish nuqtasini yaratadi.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Kalkulyator: o'z raqamingizni qo'ying" },
        {
            type: "p",
            text:
                "Quyidagi jadval bitta buyurtma bo'yicha ikki ustunni yonma-yon qo'yadi. Ustunlarni o'z raqamlaringiz bilan to'ldiring — hisob besh daqiqada chiqadi.",
        },
        {
            type: "table",
            head: ["Xarajat bandi", "Marketpleys", "O'z do'koni"],
            rows: [
                ["Komissiya / ekvayring", "Chek × kategoriya foizi (3–35%)", "Chek × shartnomadagi ekvayring foizi"],
                ["Logistika", "Har buyurtmaga 2 000–20 000 so'm", "Kuryer tarifi yoki o'z kuryeringiz tannarxi"],
                ["Trafik", "Ichki reklama, ixtiyoriy", "SEO / Ads / Instagram — majburiy band"],
                ["Qat'iy oylik", "Yo'q", "Hosting, domen, qo'llab-quvvatlash"],
                ["Bir martalik sarmoya", "Yo'q", "Saytni ishlab chiqish"],
                ["Mijoz bazasi", "Platformada qoladi", "Sizda qoladi"],
                ["Narx siyosati", "Aksiya bosimi bor", "To'liq sizda"],
            ],
        },
        {
            type: "p",
            text:
                "Misol qilib olaylik: oyiga 300 buyurtma, o'rtacha chek 250 000 so'm, kategoriya komissiyasi 15%. Oylik aylanma 75 mln so'm, komissiya 11,25 mln so'm. Ustiga 300 × 6 000 so'm logistika yig'imi — yana 1,8 mln so'm. Faqat shu ikki band oyiga 13 mln so'mdan oshadi.",
        },
        {
            type: "p",
            text:
                "O'z do'koningizda shu aylanmadan ekvayring foizi va trafik sarfi ushlanadi. Agar ular jami 13 mln so'mdan past chiqsa, ikkinchi kanal o'zini oqlay boshlaydi. Hal qiluvchi raqam — trafik narxi, chunki ekvayring foizi komissiyadan har doim ancha kichik.",
        },
        {
            type: "callout",
            text:
                "Formula: chek × komissiya % + buyurtma soni × logistika yig'imi. Chiqqan summa — o'z kanalingizga har oy ajrata oladigan byudjetingizning yuqori chegarasi.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Sayt qancha turadi va necha oyda o'zini oqlaydi?" },
        {
            type: "p",
            text:
                "Innobek'da ishlaydigan internet-do'kon 16 000 000 so'mdan boshlanadi: katalog, savat, admin panel, Payme va Click to'lovlari, yetkazib berish sozlamalari va ikki tillilik. Individual dizayn, ombor hisobi va 1C integratsiyasi bilan variant 34 000 000 so'mdan hisoblanadi.",
        },
        {
            type: "p",
            text:
                "Narxga kirmaydigan bandlar: ekvayring komissiyasi, reklama byudjeti, kontent va mahsulot fotosuratlari, kuryer xizmati. Buni loyiha boshida ochiq aytamiz — aynan shu bandlar keyin kutilmagan bo'lib chiqadi va byudjetni buzadi.",
        },
        {
            type: "p",
            text:
                "Qaytim hisobi oddiy. Yuqoridagi misolda marketpleysga oyiga 13 mln so'm ketadi. Agar o'z kanalingiz shu xarajatning yarmini tejasa — oyiga 6,5 mln so'm qoladi. 16 mln so'mlik sayt nazariy jihatdan uch oyda qaytadi.",
        },
        {
            type: "p",
            text:
                "Amalda esa birinchi uch oy trafik yig'ishga ketadi: SEO natija bermaydi, reklama sozlanmagan, kontent to'lmagan. Shuning uchun real qaytim muddatini 8–12 oy deb rejalashtiring. Uch oy deb rejalashtirsangiz, to'rtinchi oyda loyihani tashlab yuborasiz.",
        },

        { type: "h2", text: "Hech narsa qilmaslik narxi nimadan iborat?" },
        {
            type: "p",
            text:
                "Bitta kanalda qolish — bu xarajat emas, bu bog'liqlik. Uning narxi bir kunda ko'rinmaydi, lekin qoida o'zgargan kunda to'liq ko'rinadi.",
        },
        {
            type: "list",
            items: [
                "Komissiya yoki yig'im qoidasi o'zgarsa, siz shunchaki yangi qoidada yashaysiz — muzokara imkoni yo'q.",
                "Mijoz bazasi sizniki emas. Takroriy sotuvni siz emas, platforma boshqaradi.",
                "Brend qurilmaydi. Xaridor «marketpleysdan oldim» deydi, sizning nomingizni eslamaydi.",
                "Kartochka bloklansa yoki kategoriya reytingi tushsa, aylanma bir kechada yarmiga tushishi mumkin.",
                "Narx siyosati sizniki emas: aksiyalarga qo'shilish bosimi doimiy va u marjani yeydi.",
            ],
        },

        { type: "h2", text: "Qachon o'z do'koni sizga mos emas?" },
        {
            type: "p",
            text:
                "Bu bo'lim sotuv uchun emas. Quyidagi holatlarda biz o'zimiz saytdan vaqtincha voz kechishni tavsiya qilamiz — va buni loyihaga kirishdan oldin aytamiz.",
        },
        {
            type: "list",
            items: [
                "Oyiga 50 tadan kam buyurtma. Trafik sarfi hech qanday komissiya tejamini qoplamaydi.",
                "Tovaringizni xaridor atayin qidirmaydi — ko'rib qolib, impuls bilan oladi. Bunda platforma kuchliroq.",
                "Assortiment doimiy o'zgaradi va kontent yuritadigan odam yo'q. Eskirgan katalog zarar keltiradi.",
                "Marjangiz 10% dan past. Bunday marjada trafikni sotib olish deyarli imkonsiz.",
                "Jamoada buyurtmani qayta ishlaydigan odam yo'q. Sayt buyurtma keltiradi, lekin javob bermaydi.",
            ],
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Eng barqaror model — ikkala kanal birga" },
        {
            type: "p",
            text:
                "Amaliyotda eng barqaror sxema bitta: marketpleys — trafik va sinov manbai, o'z sayti — marja va mijoz bazasi manbai. Yuqori komissiyali kategoriyalarni saytga olib chiqish, past komissiyalilarini platformada qoldirish ko'pincha eng oddiy va eng tez natija beradigan optimallashtirish bo'ladi.",
        },
        {
            type: "p",
            text:
                "Ikki kanalni birga yuritishning yagona jiddiy texnik sharti bor — qoldiqni sinxronlash. Aks holda bitta tovar ikki joyda sotiladi, buyurtma bekor qilinadi va bu platformadagi reytingingizga uradi. Shuning uchun ikkinchi kanalni ochishdan oldin integratsiyani rejalashtiring.",
        },
        {
            type: "p",
            text:
                "Boshlash tartibi ham muhim. Avval marketpleysdagi haqiqiy komissiyangizni hisoblang, keyin eng yuqori komissiyali uch kategoriyani ajrating. Saytni butun assortiment uchun emas, aynan shu uch kategoriya uchun ishga tushiring. Shunda birinchi oydanoq o'lchanadigan natija bo'ladi va byudjet tarqalib ketmaydi.",
        },
    ],

    faq: [
        {
            q: "Uzum Market komissiyasi qancha?",
            a: "2026-yil 1-maydan komissiya tovar narxiga emas, tovar kategoriyasiga bog'lanadi. Diapazon kategoriyaga qarab 3% dan 35% gacha. Bundan tashqari yetkazib berish uchun qat'iy logistika yig'imi olinadi — tovar narxi va o'lchamiga qarab 2 000 so'mdan 20 000 so'mgacha. O'z kategoriyangizning aniq foizini o'rtacha raqamdan emas, sotuvchi kabinetidan oling.",
        },
        {
            q: "Qaysi aylanmadan boshlab o'z saytim foydali bo'ladi?",
            a: "Qat'iy chegara yo'q — u komissiya foizingiz va trafik narxingizga bog'liq. Formula shunday: oylik komissiya va logistika yig'imi summasi sizning saytga ajrata oladigan byudjetingizning yuqori chegarasi. Amaliyotimizda oyiga 200–300 buyurtmadan keyin hisob sayt foydasiga o'zgara boshlaydi. Oyiga 50 tadan kam buyurtmada sayt hali erta.",
        },
        {
            q: "Internet-do'kon qancha turadi va nima kirmaydi?",
            a: "Ishlaydigan do'kon 16 000 000 so'mdan: katalog, savat, admin panel, Payme va Click, yetkazib berish va ikki tillilik. Individual dizayn, ombor hisobi va 1C integratsiyasi bilan 34 000 000 so'mdan. Narxga kirmaydi: ekvayring komissiyasi, reklama byudjeti, kontent va fotosurat, kuryer xizmati. Bu bandlarni alohida rejalashtiring.",
        },
        {
            q: "Payme va Click ekvayring komissiyasi necha foiz?",
            a: "To'lov tizimlari ochiq tarif jadvalini e'lon qilmaydi. Foiz shartnomada individual belgilanadi va sizning aylanmangizga hamda tovar toifangizga bog'liq bo'ladi. Shuning uchun byudjet hisoblashda boshqa maqolalardagi taxminiy foizga tayanmang — ular tasdiqlanmagan. Arizani topshirgach, aniq stavkani va uning qayta ko'rib chiqilish shartlarini yozma ko'rinishda so'rang, so'ng hisobga kiriting.",
        },
        {
            q: "Marketpleysni tashlab, faqat saytga o'tish kerakmi?",
            a: "Yo'q, bu kam hollarda oqlanadi. Marketpleys sizga tayyor trafik, ishonch va logistika beradi — ularni noldan qurish qimmat. Barqaror model ikkala kanalni birga yuritish: platforma yangi mijoz keltiradi, sayt marjani va mijoz bazasini saqlaydi. Yuqori komissiyali kategoriyalarni saytga olib chiqing, qolganini platformada qoldiring.",
        },
        {
            q: "Ikki kanalda ishlaganda qoldiq chalkashib ketmaydimi?",
            a: "Sinxronizatsiya bo'lmasa — albatta chalkashadi. Bitta tovar ikki joyda sotiladi, buyurtmani bekor qilishga to'g'ri keladi, marketpleysdagi reyting tushadi. Yechim — qoldiq, narx va buyurtma statusini API orqali bitta manbadan yuritish. Ikkinchi kanalni ochishdan oldin shu integratsiyani rejaga kiriting, keyin qo'shish qimmatroq tushadi.",
        },
    ],

    cta: {
        h: "O'z raqamlaringiz bo'yicha hisoblab beramiz",
        p: "Kategoriyangiz, o'rtacha chekingiz va oylik buyurtma soningizni ayting — marketpleys va o'z do'koni bo'yicha taqqoslama hisobni bepul tayyorlaymiz.",
        button: "Hisobni so'rash",
    },

    images: [
        {
            src: "/assets/img/blog/ecom-cover.webp",
            alt: "Onlayn savdo — internet-do'kon va marketpleys o'rtasidagi tanlov",
            caption: "Bozor o'sdi, komissiya ham o'sdi — tanlov endi hisob-kitob masalasi",
        },
        {
            src: "/assets/img/blog/ecom-unit-economics.webp",
            alt: "Bitta buyurtma uchun marketpleys va o'z do'koni xarajatlarining taqqoslanishi",
            caption: "Bitta buyurtmaning to'liq tannarxi: komissiya, logistika, trafik va marja",
            prompt:
                "Two-column unit-economics comparison chart for a single order: left stacked bar 'marketplace' split into commission, logistics fee, ads, returns, net margin; right stacked bar 'own store' split into acquiring, delivery, traffic cost, site amortisation, net margin; clean data-viz style, blue and teal, axis in percent, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-break-even.webp",
            alt: "Oylik buyurtma soni bo'yicha nuqtai teng kelish grafigi",
            caption: "Kesishish nuqtasi — o'z kanalingiz arzonlashadigan buyurtma hajmi",
            prompt:
                "Break-even line chart: horizontal axis monthly order volume, two lines crossing at a break-even point marked with a dot — marketplace total cost rising steeply, own-store total cost starting higher then flattening; minimal analytics UI, blue and amber lines, annotated crossing point, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/bobo-market.webp",
            alt: "Bobo Market internet-do'koni — katalog va buyurtma sahifasi",
            caption: "Bobo Market — o'z kanali sifatida ishlaydigan internet-do'kon",
        },
    ],

    relatedServices: ["internet-dokonlar", "seo", "erp-tizimlar"],
    relatedPosts: ["onlayn-tolov-ulash-payme-click", "marketpleys-va-sayt-sinxronizatsiya", "internetdokon"],
};

const ru = {
    meta: {
        title: "Маркетплейс или свой интернет-магазин: расчёт 2026",
        description:
            "Комиссия маркетплейса 3–35% плюс логистический сбор 2–20 тысяч сум. Когда свой магазин дешевле — открытый калькулятор, таблица и срок окупаемости.",
        keywords: [
            "маркетплейс или свой интернет-магазин что выгоднее",
            "комиссия Uzum Market для продавцов",
            "стоимость интернет-магазина Ташкент",
            "уйти с маркетплейса на свой сайт",
            "юнит-экономика продаж онлайн",
        ],
    },
    h1: "Маркетплейс или собственный интернет-магазин: где остаётся больше денег",
    lead:
        "Маркетплейс даёт трафик, но забирает комиссию. Свой магазин комиссию не берёт, но трафик вы покупаете сами. Что выгоднее — это не вопрос вкуса, а расчёт, который умещается в одну таблицу.",
    category: "Электронная коммерция",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "Самый частый вопрос, который нам задают: «Мы продаём на маркетплейсе, нужен ли нам свой сайт?» Универсального ответа нет. Он зависит от вашей категории, среднего чека и числа заказов в месяц. Ниже мы показываем расчёт открыто — вы подставите свои цифры.",
        },

        { type: "h2", text: "Почему этот вопрос обострился именно в 2026 году?" },
        {
            type: "p",
            text:
                "По итогам 2025 года оборот электронной коммерции в Узбекистане составил 22,7 трлн сум — это более чем в 22 раза больше показателя 2020 года и в 1,5 раза выше прошлогоднего. За тот же период число электронных торговых платформ выросло с 36 до 115. Рынок вырос, но вместе с ним выросла и конкуренция между продавцами.",
        },
        {
            type: "p",
            text:
                "С 1 мая 2026 года Uzum Market изменил механику начисления комиссии. Теперь она привязана не к цене товара, а к его категории, и диапазон широкий — от 3% до 35% в зависимости от категории. С той же даты введён фиксированный логистический сбор за доставку: от 2 000 до 20 000 сум в зависимости от цены и габаритов товара.",
        },
        {
            type: "p",
            text:
                "Эти два изменения переписали юнит-экономику продавца. На дешёвых и мелких товарах фиксированный сбор теперь съедает заметную часть маржи. В дорогих категориях сильнее сказывается высокий процент. Раньше можно было оперировать «средней комиссией», теперь каждая категория считается отдельно.",
        },
        {
            type: "p",
            text:
                "Сигнал есть и со стороны государства: постановлением президента от 13 апреля 2026 года поставлена задача довести оборот электронной коммерции до 30 трлн сум к 2030 году. Канал продолжит расти. Поэтому держать все продажи на одной платформе становится всё более рискованным решением.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Что даёт маркетплейс и почему это нельзя обесценивать" },
        {
            type: "p",
            text:
                "Комиссию легко воспринимать как чистый расход, но взамен вы получаете вполне конкретные вещи. Если их не учесть, сравнение окажется некорректным с самого начала.",
        },
        {
            type: "list",
            items: [
                "Готовый трафик. Покупатель сам приходит на площадку за товаром — вы за этот приход не платите.",
                "Готовое доверие. Площадка берёт на себя страх первого заказа у незнакомого бренда.",
                "Готовая логистика. Склад, пункты выдачи, курьеры и поток возвратов уже работают.",
                "Нулевые стартовые вложения. Разместили товар — завтра можно продавать.",
                "Быстрая проверка гипотез. Пойдёт ли новый товар, вы поймёте за одну-две недели.",
            ],
        },
        {
            type: "p",
            text:
                "Поэтому мы никогда не советуем «уходить с маркетплейса». Правильный вопрос звучит иначе: с какого оборота второй канал начинает приносить деньги и что именно он берёт на себя.",
        },

        { type: "h2", text: "Сколько стоит один заказ на маркетплейсе?" },
        {
            type: "p",
            text:
                "Считайте не месячный оборот, а полную стоимость одного заказа. Только так два канала можно поставить на одни весы.",
        },
        {
            type: "ol",
            items: [
                "Комиссия: чек × процент категории. На Uzum это от 3% до 35% — берите процент своей категории из кабинета продавца, а не среднее по рынку.",
                "Логистический сбор: от 2 000 до 20 000 сум за каждый доставленный заказ, в зависимости от цены и габаритов.",
                "Внутренняя реклама: затраты на удержание позиции. В конкурентной категории это постоянная статья.",
                "Возвраты: логистика вернувшегося товара и потеря его товарного вида.",
                "Акции и скидки: участие в кампаниях площадки на практике редко бывает по-настоящему добровольным.",
            ],
        },
        {
            type: "p",
            text:
                "Большинство продавцов считает только первый пункт. В реальности полная стоимость заказа заметно выше — особенно в категориях с низким средним чеком.",
        },

        { type: "h2", text: "Сколько стоит один заказ в собственном магазине?" },
        {
            type: "p",
            text:
                "Здесь структура расходов другая: процент заметно ниже, но трафик платный, а сайт требует разовых вложений.",
        },
        {
            type: "ol",
            items: [
                "Комиссия эквайринга. Payme, Click и Uzum не публикуют открытый тариф — процент определяется в договоре индивидуально и зависит от вашего оборота. До подписания запросите точную ставку письменно.",
                "Стоимость трафика: SEO, Google Ads или Instagram. Это самая крупная и самая изменчивая статья в себестоимости заказа.",
                "Доставка: тариф курьерской службы или себестоимость собственного курьера.",
                "Амортизация сайта: стоимость разработки, разнесённая на 12–24 месяца.",
                "Хостинг, домен и техническая поддержка — небольшая, но фиксированная ежемесячная сумма.",
            ],
        },
        {
            type: "p",
            text:
                "Ключевая разница вот в чём: на маркетплейсе расходы растут пропорционально обороту, а в своём магазине бо́льшая их часть остаётся фиксированной. Чем выше оборот, тем меньше фиксированных расходов приходится на один заказ. Именно это и создаёт точку пересечения.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Калькулятор: подставьте свои цифры" },
        {
            type: "p",
            text:
                "Таблица ниже ставит два канала рядом в расчёте на один заказ. Заполните колонки своими данными — расчёт занимает пять минут.",
        },
        {
            type: "table",
            head: ["Статья расходов", "Маркетплейс", "Свой магазин"],
            rows: [
                ["Комиссия / эквайринг", "Чек × процент категории (3–35%)", "Чек × процент эквайринга по договору"],
                ["Логистика", "2 000–20 000 сум за заказ", "Тариф курьерской службы или свой курьер"],
                ["Трафик", "Внутренняя реклама, формально по желанию", "SEO / Ads / Instagram — обязательная статья"],
                ["Фиксированные расходы", "Нет", "Хостинг, домен, поддержка"],
                ["Разовые вложения", "Нет", "Разработка сайта"],
                ["База клиентов", "Остаётся у площадки", "Остаётся у вас"],
                ["Ценовая политика", "Давление акций площадки", "Полностью ваша"],
            ],
        },
        {
            type: "p",
            text:
                "Возьмём пример: 300 заказов в месяц, средний чек 250 000 сум, комиссия категории 15%. Месячный оборот — 75 млн сум, комиссия — 11,25 млн сум. Сверху 300 × 6 000 сум логистического сбора, то есть ещё 1,8 млн. Только эти две статьи дают больше 13 млн сум в месяц.",
        },
        {
            type: "p",
            text:
                "В собственном магазине из того же оборота удерживаются процент эквайринга и расходы на трафик. Если в сумме они выходят меньше 13 млн сум, второй канал начинает окупаться. Решающая цифра здесь — стоимость трафика, потому что процент эквайринга всегда существенно ниже комиссии площадки.",
        },
        {
            type: "callout",
            text:
                "Формула: чек × процент комиссии + число заказов × логистический сбор. Полученная сумма — верхняя граница бюджета, который вы можете ежемесячно направлять на собственный канал.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Сколько стоит сайт и за сколько он окупается?" },
        {
            type: "p",
            text:
                "В Innobek работающий интернет-магазин начинается от 16 000 000 сум: каталог, корзина, админ-панель, оплата через Payme и Click, настройки доставки и двуязычность. Вариант с индивидуальным дизайном, складским учётом и интеграцией с 1С считается от 34 000 000 сум.",
        },
        {
            type: "p",
            text:
                "В цену не входят: комиссия эквайринга, рекламный бюджет, контент и товарная фотосъёмка, курьерская служба. Мы говорим об этом в начале проекта — именно эти статьи потом оказываются неожиданными и ломают бюджет.",
        },
        {
            type: "p",
            text:
                "Расчёт окупаемости простой. В примере выше на маркетплейс уходит 13 млн сум в месяц. Если собственный канал экономит половину этой суммы, у вас остаётся 6,5 млн сум ежемесячно. Сайт за 16 млн сум теоретически окупается за три месяца.",
        },
        {
            type: "p",
            text:
                "На практике первые три месяца уходят на набор трафика: SEO ещё не даёт результата, реклама не откручена, контент не заполнен. Поэтому планируйте реальный срок окупаемости в 8–12 месяцев. Если заложить три месяца, на четвёртом вы бросите проект.",
        },

        { type: "h2", text: "Из чего складывается цена бездействия?" },
        {
            type: "p",
            text:
                "Остаться в одном канале — это не расход, это зависимость. Её цена не видна каждый день, но видна целиком в день, когда меняются правила.",
        },
        {
            type: "list",
            items: [
                "Меняется правило комиссии или сбора — вы просто живёте по новому правилу, переговорной позиции нет.",
                "База клиентов не ваша. Повторными продажами управляете не вы, а площадка.",
                "Бренд не строится. Покупатель говорит «купил на маркетплейсе», вашего названия он не запоминает.",
                "Блокировка карточки или падение рейтинга в категории способны срезать оборот вдвое за одну ночь.",
                "Ценовая политика не ваша: давление акций постоянно, и оно съедает маржу.",
            ],
        },

        { type: "h2", text: "Когда собственный магазин вам не подходит?" },
        {
            type: "p",
            text:
                "Этот раздел написан не для продажи. В перечисленных ниже ситуациях мы сами советуем отложить сайт — и говорим об этом до старта проекта.",
        },
        {
            type: "list",
            items: [
                "Меньше 50 заказов в месяц. Расходы на трафик не покроет никакая экономия на комиссии.",
                "Ваш товар не ищут целенаправленно — его покупают импульсивно, увидев в ленте. Здесь площадка сильнее.",
                "Ассортимент меняется постоянно, а вести контент некому. Устаревший каталог приносит убыток.",
                "Маржа ниже 10%. При такой марже покупать трафик практически невозможно.",
                "В команде некому обрабатывать заказы. Сайт приведёт заявку, но отвечать на неё он не будет.",
            ],
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Самая устойчивая модель — два канала вместе" },
        {
            type: "p",
            text:
                "На практике устойчивая схема одна: маркетплейс как источник трафика и тестов, собственный сайт как источник маржи и клиентской базы. Вывести на сайт категории с высокой комиссией и оставить на площадке те, где комиссия низкая, — часто самая простая и самая быстрая оптимизация.",
        },
        {
            type: "p",
            text:
                "У параллельной работы двух каналов есть одно серьёзное техническое условие — синхронизация остатков. Иначе один и тот же товар продаётся дважды, заказ приходится отменять, а это бьёт по рейтингу на площадке. Поэтому интеграцию закладывайте до запуска второго канала.",
        },
    ],

    faq: [
        {
            q: "Какая комиссия у Uzum Market?",
            a: "С 1 мая 2026 года комиссия привязана не к цене товара, а к его категории. Диапазон — от 3% до 35% в зависимости от категории. Дополнительно взимается фиксированный логистический сбор за доставку: от 2 000 до 20 000 сум в зависимости от цены и габаритов товара. Точный процент своей категории берите в кабинете продавца, а не из средних оценок.",
        },
        {
            q: "С какого оборота свой сайт становится выгодным?",
            a: "Жёсткого порога нет — он зависит от вашего процента комиссии и стоимости трафика. Ориентир такой: сумма месячной комиссии и логистических сборов и есть верхняя граница бюджета на собственный канал. В нашей практике расчёт начинает склоняться в пользу сайта после 200–300 заказов в месяц. При 50 заказах сайт ещё преждевременен.",
        },
        {
            q: "Сколько стоит интернет-магазин и что не входит в цену?",
            a: "Работающий магазин — от 16 000 000 сум: каталог, корзина, админ-панель, Payme и Click, доставка и двуязычность. С индивидуальным дизайном, складским учётом и интеграцией с 1С — от 34 000 000 сум. Не входят: комиссия эквайринга, рекламный бюджет, контент и фотосъёмка, курьерская служба. Эти статьи планируйте отдельно.",
        },
        {
            q: "Какой процент эквайринга у Payme и Click?",
            a: "Платёжные системы не публикуют открытую тарифную сетку. Процент определяется в договоре индивидуально и зависит от вашего оборота и товарной категории. Поэтому при расчёте бюджета не опирайтесь на приблизительные проценты из чужих статей: после подачи заявки запросите точную ставку письменно и внесите её в расчёт.",
        },
        {
            q: "Нужно ли уходить с маркетплейса полностью на сайт?",
            a: "Нет, такое решение оправдано редко. Маркетплейс даёт готовый трафик, доверие и логистику — построить это с нуля дорого. Устойчивая модель — вести оба канала: площадка приводит новых покупателей, сайт сохраняет маржу и клиентскую базу. Выведите на сайт категории с высокой комиссией, остальное оставьте на площадке.",
        },
        {
            q: "Не перепутаются ли остатки при работе в двух каналах?",
            a: "Без синхронизации — обязательно перепутаются. Один товар продаётся дважды, заказ приходится отменять, рейтинг на площадке падает. Решение — вести остатки, цены и статусы заказов из одного источника через API. Заложите эту интеграцию до открытия второго канала: добавлять её позже выходит дороже.",
        },
    ],

    cta: {
        h: "Посчитаем по вашим цифрам",
        p: "Назовите категорию, средний чек и число заказов в месяц — бесплатно подготовим сравнительный расчёт по маркетплейсу и собственному магазину.",
        button: "Запросить расчёт",
    },

    images: [
        {
            src: "/assets/img/blog/ecom-cover.webp",
            alt: "Онлайн-торговля — выбор между интернет-магазином и маркетплейсом",
            caption: "Рынок вырос, комиссии тоже — выбор стал вопросом расчёта",
        },
        {
            src: "/assets/img/blog/ecom-unit-economics.webp",
            alt: "Сравнение расходов на один заказ: маркетплейс и собственный магазин",
            caption: "Полная себестоимость заказа: комиссия, логистика, трафик и маржа",
            prompt:
                "Two-column unit-economics comparison chart for a single order: left stacked bar 'marketplace' split into commission, logistics fee, ads, returns, net margin; right stacked bar 'own store' split into acquiring, delivery, traffic cost, site amortisation, net margin; clean data-viz style, blue and teal, axis in percent, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-break-even.webp",
            alt: "График точки безубыточности по числу заказов в месяц",
            caption: "Точка пересечения — объём заказов, при котором свой канал дешевле",
            prompt:
                "Break-even line chart: horizontal axis monthly order volume, two lines crossing at a break-even point marked with a dot — marketplace total cost rising steeply, own-store total cost starting higher then flattening; minimal analytics UI, blue and amber lines, annotated crossing point, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/bobo-market.webp",
            alt: "Интернет-магазин Bobo Market — каталог и страница заказа",
            caption: "Bobo Market — интернет-магазин, работающий как собственный канал",
        },
    ],

    relatedServices: ["internet-dokonlar", "seo", "erp-tizimlar"],
    relatedPosts: ["onlayn-tolov-ulash-payme-click", "marketpleys-va-sayt-sinxronizatsiya", "internetdokon"],
};

const content = { uz, ru };

export default content;
